import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import StandardModal from "../../../../Components/Modals/StandardModal";
import ActionButton from "../../../../Components/Buttons/ActionButton";
import { hideModal } from "../../../../Redux/GlobalReducer";
import CharacterCounter from "../../../../Components/Inputs/CharacterCounter";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import { signInBooking } from "../../Requests/BookingListRequests";

export const SEARCHED_AT_SIGN_IN_MODAL = 'searchedAtSignInModal';

const SearchedAtSignInModal = (props) => {
    const dispatch = useDispatch();

    //const booking = useSelector(state => state.module.BOOKINGS.bookingForm.booking)
    const searchedAtSignInModal = useSelector((state) => state.global.openModals?.[SEARCHED_AT_SIGN_IN_MODAL]);

    const [searchNotes, setSearchNotes] = useState('');

    const handleClose = () => {
        dispatch( hideModal(SEARCHED_AT_SIGN_IN_MODAL) )
    }

    const handleClick = (wasSearched) => {
        dispatch( signInBooking(
            searchedAtSignInModal.view,
            searchedAtSignInModal.type,
            searchedAtSignInModal.bookingId,
            wasSearched,
            searchNotes
        ) );
    }

    return (
        <StandardModal
            open={!!searchedAtSignInModal}
            onClose={handleClose}
            title="Searched?"
            style={{
                minWidth: 700
            }}
        >
            <form>

                <FormRow
                    label="Search Notes"
                >
                    <CharacterCounter
                        max={255}
                        value={searchNotes}
                        onChange={(e) => setSearchNotes(e.target.value)}
                    >
                            <textarea
                                name="searchNotes"
                                value={searchNotes}
                                onChange={(e) => setSearchNotes(e.target.value)}
                                rows={4}
                                style={{ resize: 'none' }}
                            />
                    </CharacterCounter>
                </FormRow>

                <div className="grid-x margin-top-2">
                    <div className="cell auto text-right">
                        <div className="button-group align-right text-right margin-bottom-0">
                            <ActionButton
                                className="secondary width-1"
                                onClick={() => handleClick(false)}
                                title="No"
                            />
                            <ActionButton
                                className="width-1"
                                onClick={() => handleClick(true)}
                                title="Yes"
                                animateOnClick
                            />
                        </div>
                    </div>
                </div>

            </form>
        </StandardModal>
    )
}

export default SearchedAtSignInModal;
